import React from "react";
import { FaArrowRightLong } from "react-icons/fa6";
import { Link } from "react-router-dom";

const ServiceCard = ({ index, img, icon, heading, text, id }) => {
  return (
    <Link data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100}
      to={`/service/${id}`} className="relative snap-center shrink-0 w-full md:w-[22rem] lg:w-[20rem] bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 group cursor-pointer">

      <div className="w-full h-[210px] overflow-hidden">
        <img
          src={img}
          alt={heading}
          className="w-full h-full object-cover transition-all duration-500 group-hover:scale-105"
        />
      </div>

      <div
        className="absolute right-6 -translate-y-1/2 w-20 h-20 bg-primaryFadedColor flex items-center justify-center rounded-[12px]
        transition-transform duration-500 group-hover:rotate-45"
      >
        <img
          src={icon}
          alt="icon"
          className="w-9 h-9 object-contain group-hover:rotate-45 pointer-events-none transition-all"
        />
      </div>

      <div className="px-6 pt-10 pb-6">
        <h3 className="text-xl font-semibold text-primaryNavyTextColor mb-3">{heading}</h3>
        <p className="text-secondaryTextColor leading-relaxed text-ellipsis line-clamp-4 text-[15px] min-h-[85px]">
          {text}
        </p>

        <div className="mt-6 flex items-center gap-3 text-primaryNavyTextColor font-medium relative">
          <span className="text-[15px]">READ MORE</span>

          <FaArrowRightLong
            className="text-[18px] transition-all duration-300 group-hover:translate-x-2"
          />
        </div>
      </div>
    </Link>
  );
};

export default ServiceCard;
